import React from 'react';
import Markdown from "../Markdown";
import { useUser } from '../../../util/user';

import dataDownloadMd from './dataDownload.md';
import dataDownloadITMd from './dataDownloadIT.md';
import dataDownloadGYMd from './dataDownloadGY.md';

export default function DataDownloadDoc({ onMarkdownLoaded }) {
	const userObj = useUser();
	return (
		<>
			<Markdown id="data-download" markdown={dataDownloadMd} onLoad={onMarkdownLoaded} />
			{userObj?.roles?.includes('_GY:Base') && (
				<Markdown id="data-download-gy" markdown={dataDownloadGYMd} onLoad={onMarkdownLoaded} />
			)}
			{userObj?.roles?.includes('_GY:IT') && (
				<Markdown id="data-download-it" markdown={dataDownloadITMd} onLoad={onMarkdownLoaded} />
			)}
		</>
	);
}